import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {  allProgram, program_inactive } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Tooltip, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Modal, Button, Typography } from "@mui/material";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";

const AllPrograms = ({ userData,role }) => {
  const [error, setErrors] = useState({});

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState(0);
  const [Subcastes, setSubCastes] = useState([]);
  const location = useLocation();
  const rowData = location.state;


  useEffect(() => {
    setIsLoading(true);
    let data = {
      gm_id: userData.data.gm_id,
    };
    allProgram(data)
      .then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data.program);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
    setIsLoading(false);
  }, []);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();
  const view = (row) => {
    navigate(`/launch-program`, { state: row });
  };

  const view1 = (rowId) => {
    navigate(`/all-program-question/${rowId}`);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleImageClick = (imageData) => {
    var w = window.open('about:blank');
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement('iframe')).src = "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = '100%';
      w.document.getElementsByTagName("iframe")[0].style.height = '100%';
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  const toggleStatus = (rowId, currentStatus) => {
    setIsLoading(true);
    let data = {
      program_id: rowId,
    };
    program_inactive(data)
      .then((res) => {
        if (res.status === "success") {
          toast.success(res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
    setIsLoading(false);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("All Programs")}</h5>
          <div style={{display: role == 7 ? "none" : "block"}}>
            <button className="btn btn-primary btn-sm" onClick={() => view()}>
              <AddIcon />
              {t("Add Program")}
            </button>
            
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Program Name")}</TableCell>
                  <TableCell align="center">{t("Total Questions")}</TableCell>
                  <TableCell align="center">{t("Image")}</TableCell>
                  <TableCell align="center">{t("Posted At")}</TableCell>
                  <TableCell align="center">{t("Status")}</TableCell>
                  <TableCell align="center">{t("Action")}</TableCell>
                  <TableCell align="center">{t("Set Question")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.additionalData.name}
                        </TableCell>
                        <TableCell align="center">{row.additionalData.total_questions}</TableCell>
                        <TableCell align="center">
                          {row.image && <img src={`data:image/png;base64,${row.image}`} className="border border-3" alt="Checklist" style={{ width: "50px", borderRadius: "50%", height: "50px" }} onClick={() => handleImageClick(row.image)} />}
                        </TableCell>
                        <TableCell align="center">{row.additionalData.posted_at}</TableCell>
                        <TableCell align="center" style={{ width: "10%" }}>
                          {row.additionalData.status === 1 ? "Active" : "InActive"}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color={
                              row.additionalData.status === 1
                                ? "secondary"
                                : "primary"
                            }
                            onClick={() =>
                              toggleStatus(
                                row.additionalData.id,
                                row.additionalData.status
                              )
                            }
                          >
                            {row.additionalData.status === 1
                              ? "Deactivate"
                              : "Activate"}
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="Add Question">
                            <IconButton onClick={() => view1(row.additionalData.id)}>
                              <BorderColorOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>{t("No data available")}</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default AllPrograms;
